'use client';

import { useEffect, useState } from 'react';
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  // Mobile gets top-center so toasts don't fight the bottom nav / safe area.
  // Desktop keeps bottom-right out of the way of primary content.
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mql = window.matchMedia('(max-width: 640px)');
    // eslint-disable-next-line react-hooks/set-state-in-effect -- sync local mql state on mount
    setIsMobile(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      position={isMobile ? 'top-center' : 'bottom-right'}
      closeButton={!isMobile}
      offset={isMobile ? 12 : 24}
      mobileOffset={12}
      toastOptions={{
        classNames: {
          toast:
            'backdrop-blur-sm !text-sm !py-3 !px-4 max-sm:!w-[calc(100vw-1.5rem)] max-sm:!max-w-none',
          title: 'font-semibold',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': '14px',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
